import React from 'react'
import { Props } from 'models/sectionPromotions'
import { MyPromotions } from './Promotions.styles'
import { MyCardOne } from 'modules/common/Cards/CardOne.styles'

import { Headline } from 'modules/common/Headline/Headline'

import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const responsive = {
    desktop1: {
        breakpoint: { max: 3000, min: 1480 },
        items: 2,
        partialVisibilityGutter: 128
    },

    desktop2: {
        breakpoint: { max: 1479, min: 1025 },
        items: 2,
        partialVisibilityGutter: 80
    },

    tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 1,
        partialVisibilityGutter: 400
    },

    mobile: {
        breakpoint: { max: 767, min: 0 },
        items: 1,
        partialVisibilityGutter: 40
    }
}

export const Promotions: React.FC<Props> = ({id, dataPromotions}) => {
    const dataPromo = dataPromotions?.[0];

    if(!dataPromo) return null;

    return(
        <MyPromotions.block id={id}>
            <MyPromotions.wrapper>
                <Headline
                    props={{
                        title: dataPromo.title,
                        description: dataPromo.description
                    }}
                />
                
                <Carousel partialVisible={true} responsive={responsive}>
                    { dataPromo.promotions?.map(item => (
                        <MyCardOne.block key={item.id} className="inactive-promotion">
                            <MyCardOne.wraoImage>
                                <MyCardOne.image src={item.images} />
                            </MyCardOne.wraoImage>
                            
                            <MyCardOne.wrapper>
                                <MyCardOne.title>{item.title}</MyCardOne.title>
                                
                                <MyCardOne.validity>
                                    Promoção encerrada
                                </MyCardOne.validity>

                                { item.actions?.[0].url &&
                                    <MyCardOne.CTA href={item.actions?.[0].url}>
                                        {item.actions?.[0].title}
                                    </MyCardOne.CTA>
                                }
                            </MyCardOne.wrapper>
                        </MyCardOne.block>
                    ))}
                </Carousel>
            </MyPromotions.wrapper>
        </MyPromotions.block>
    )
}